const actions = {
  SET_STATE: 'analytics/SET_STATE',
  GET_TOTAL_REGISTRATIONS: 'analytics/GET_TOTAL_REGISTRATIONS',
  GET_SCENE_DATA: 'analytics/GET_SCENE_DATA',
  GET_CURRENT_DATA: 'analytics/GET_CURRENT_DATA',
}

export default actions
